import { Typography } from "@mui/material";
import { PaintMarker } from "../mapa";
import { Marker } from "leaflet";

export interface AcomodacaoData {
  id: number;
  idBarragem: number;
  nome: string;
  lat: number;
  lng: number;
  alt?: number;
  tipo: string;
  endereco: string;
  municipio: number;
  instalacoes?: string;
  style?: PaintMarker;

  dataCadastro: Date;
  dataModificacao?: Date;
  idUpdate: string;
}

export class Acomodacao extends Marker<AcomodacaoData> {
  public style?: PaintMarker;

  public properties: AcomodacaoData;
  constructor(properties: AcomodacaoData, style?: PaintMarker) {
    super([properties.lat, properties.lng, properties.alt], style);

    this.properties = properties;
    this.style = style;

    if (this.style && this.style.bindPopUp) {
      this.bindPopup(this.popUpComponent(), {
        className: "",
        maxWidth: 390,
      });
    }
    if (this.style && this.style.bindTooltip) {
      this.bindTooltip(this.tooltipComponent(), { direction: "top" });
    }
  }

  public popUpComponent() {
    return window.JSXToHTML(
      <div style={{
        display: "flex",
        flexDirection: "column",
        justifyItems: "center",
        height: "10em",
        width: "19em",
        overflowY: "auto",
      }}>
        <Typography fontSize={"1.2em"} fontWeight={"bold"}>
          {this.properties.nome}
        </Typography>
      </div>
    );
  }

  public tooltipComponent() {
    return window.JSXToHTML(
      <div style={{
        display: "flex",
        flexDirection: "column",
        justifyItems: "center",
        overflowY: "auto",
      }}>
        <Typography fontSize={"1.2em"} fontWeight={"bold"}>
          {this.properties.nome}
        </Typography>
        <Typography>
          {this.properties.tipo}
        </Typography>
      </div>
    );
  }
}